import type { FaireProductEntity } from "../../entity_types/product";

export const p_2yhpaj9zc2: FaireProductEntity = {
  token: "p_2yhpaj9zc2",
  type: "product",
  name: "Nothing Matters Stress Toy X Adam Jk",
  brandToken: "b_3fio9sxbn1",
  brandName: "Third Drawer Down USA",
  imageUrl:
    "https://cdn.faire.com/fastly/3a6a38a8c7af2645256b168a03f2432767cafa6e8ed58fd8cecd13426f899d0d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/af43bf82f42566e7f2b4bf487f58fc501541c290a115e92658f97d964729638e.jpeg",
    "https://cdn.faire.com/fastly/eccc9a4a027c698013edd047561c05b8fa8605ad5a5ee6740c8768381f84057a.jpeg",
    "https://cdn.faire.com/fastly/9331e5fa8d35f21f46f355cb53a5c52f61823083c529d1767c4b8977988c52eb.jpeg",
  ],
  priceDollars: 5.9,
  description:
    "Find some comfort in this stress toy from Adam JK, sure to help you overcome your woes with a good squeeze and a healthy dose of nihilism.\n\n𝐀𝐛𝐨𝐮𝐭 𝐭𝐡𝐞 𝐚𝐫𝐭𝐢𝐬𝐭\nAdam J. Kurtz (aka Adam JK) is a designer, artist, and speaker whose illustrative work is rooted in honesty, humor and a little darkness. His books have been translated into over a dozen languages.\n\nKurtz speaks frankly about channeling human emotion into our art, and generally just trying to be more okay with whatever we've got.\n\n𝐒𝐩𝐞𝐜𝐢𝐟𝐢𝐜𝐚𝐭𝐢𝐨𝐧𝐬\n• PU Foam\n• 3.14 x 2.9 inch",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:39.097Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
